import React from "react";
import {Box} from "@unibuddy/patron";
import get from "lodash/get";
import MentorCardBanner from "shared/Mentor/components/MentorCardBanner/MentorCardBanner";
import MentorCardSeparator from "shared/Mentor/components/MentorCardSeparator/MentorCardSeparator";
import {MentorCardSectionItem} from "shared/Mentor/components/MentorCardSectionItem/MentorCardSectionItem";
import {Flag} from "shared/Buddies/components/Flag/Flag";
import {useTranslation} from "@unibuddy/intl";
import MentorCardName from "shared/Mentor/components/MentorCardName/MentorCardName";
import MentorCardDegree from "shared/Mentor/components/MentorCardDegree/MentorCardDegree";
import {compose} from "redux";
import withAnalytics from "shared/AnalyticsNew/withAnalytics/withAnalytics";
import withAuth from "shared/Auth/withAuth/withAuth";
import PillButton from "shared/General/components/PillButton/PillButton";
import ThemedLink from "shared/Navigation/components/ThemedLink/ThemedLink";

const MentorPreviewCard = (props) => {
    const {t} = useTranslation(["mentorCard"]);
    return (
        <Box
            backgroundColor="white"
            borderRadius="xsmall"
            borderColor="grey150"
            borderWidth={0.5}
            w={["240px", "340px"]}
            color="grey900"
        >
            <MentorCardBanner
                name={props.firstName}
                profilePhoto={props.profilePhoto}
                lastSeen={props.lastSeen}
                imageClickable={false}
            />
            <MentorCardName name={props.firstName} />
            <MentorCardDegree
                degree={
                    props.isDegreeTypesEnabled
                        ? get(props, "degrees[0].degree.name")
                        : get(props, "degree.name")
                }
            />
            <MentorCardSeparator />

            <MentorCardSectionItem label={t("iComeFrom", "I come from")}>
                {props.country?.name}
                &nbsp;
                {props.isShowCountryFlagEnabled && (
                    <Flag
                        countryCode={get(props, "country.code", "")}
                        primaryFlag={get(props, "mentorFields.primaryFlag.code", "")}
                        secondaryFlag={get(props, "mentorFields.secondaryFlag.code", "")}
                        position={"right"}
                        className={""}
                    />
                )}
            </MentorCardSectionItem>

            <MentorCardSectionItem label={t("previousStudies", "Previous Qualification")} last>
                {props.pastQualification}
            </MentorCardSectionItem>

            <Box paddingX={"small"} marginBottom={"small"}>
                <ThemedLink
                    to={get(props, "amboChatLink")}
                    external={false}
                    onClick={() => {
                        props.analytics.events.chatWithAmbassadorsViaActions({
                            ambassadorId: get(props, "ambassadorId"),
                            prospectId: get(props, "authState.me.anyUser.id"),
                            sharedURL: get(props, "shareUrl"),
                            shareType: "AMBASSADOR",
                        });
                    }}
                >
                    <PillButton full invert large={false} className={""}>
                        {/* FIXME: This translation key doesn't exists */}
                        {t("chatToAmbassador", "Chat to Ambassador")}
                    </PillButton>
                </ThemedLink>
            </Box>
        </Box>
    );
};

export default compose(withAnalytics, withAuth)(MentorPreviewCard);
